"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailChimpUserProfileBase = exports.MailChimpEventType = exports.MailChimpTag = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../../constants");
var MailChimpTag;
(function (MailChimpTag) {
    MailChimpTag["RegisteredPopSuite"] = "REGISTERED_POPSUITE";
    MailChimpTag["RegisteredPopTeams"] = "REGISTERED_POPTEAMS";
    MailChimpTag["RegisteredPopQuiz"] = "REGISTERED_POPQUIZ";
    MailChimpTag["RegisteredPopStudy"] = "REGISTERED_POPSTUDY";
    MailChimpTag["RegisteredPopStack"] = "REGISTERED_POPSTACK";
})(MailChimpTag = exports.MailChimpTag || (exports.MailChimpTag = {}));
var MailChimpEventType;
(function (MailChimpEventType) {
    MailChimpEventType["Registered"] = "REGISTERED";
})(MailChimpEventType = exports.MailChimpEventType || (exports.MailChimpEventType = {}));
class MailChimpUserProfileBase {
    constructor(uid, email, firstName, lastName) {
        this.tags = [];
        this.uid = uid;
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
    }
    static collectionPath() {
        return constants_1.constants.COLLECTION_PATH_MAILCHIMP_USER;
    }
}
exports.MailChimpUserProfileBase = MailChimpUserProfileBase;
